import { render, staticRenderFns } from "./PerfuroCortante.vue?vue&type=template&id=4b1adfb4&"
import script from "./PerfuroCortante.vue?vue&type=script&lang=js&"
export * from "./PerfuroCortante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports